import { Component } from '@angular/core';
import { SwPush } from '@angular/service-worker';
import { ActivatedRoute } from '@angular/router';
import { SubscriptionService } from './services/subscription.service';
import { VersionCheckService } from './version-check.service';


@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css'],
  standalone: false
})
export class AppComponent {
  title = 'foodmine-course';

  constructor(
    private subscriptionService: SubscriptionService,
    private route: ActivatedRoute,
    private versionCheckService: VersionCheckService
  ) { 
     this.versionCheckService.initVersionCheck();
  }

  ngOnInit() {
    this.route.queryParams.subscribe(params => {
      const id = params['id'];
      const local = params['local'];
    });
    navigator.serviceWorker.getRegistrations().then(registrations => {
      if (registrations.length === 0) {

        navigator.serviceWorker.register('/custom-service-worker.js')
          .then(reg => {
            console.log('Service Worker registrado:', reg);
            window.location.reload(); // recarrega após sucesso
          })
          .catch(err => console.error('Erro ao registrar SW:', err));
      } else {
        console.log('Service Worker já registrado:', registrations);
      }
    });
  }
}
